import styled from "styled-components";

export const BaseButton = styled.button`
  display: ${(props) => props.display};
  flex-direction: ${(props) => props.flexDirection};
  text-align: center;
  text-transform: capitalize;
  padding-top: ${(props) => props.paddingBlock}px;
  padding-bottom: ${(props) => props.paddingBlock}px;
  padding-inline-end: ${(props) => props.paddingInLine}px;
  padding-inline-start: ${(props) => props.paddingInLine}px;
  border-radius: ${(props) => props.borderRadius};
  font-size: ${(props) => props.fontSize}px;
  line-height: ${(props) => props.lineHeight};
  font-family: arimo, arial;
  border: 1px solid;
  cursor: ${(props) => props.cursor};
  outline: none;
  ${(props) => props.baseStyle};
  &:hover {
    ${(props) => props.hoverStyle}
  }
  &:active {
    ${(props) => props.activeStyle}
  }
  height: fit-content;
  width: ${(props) => props.width};
  justify-content: center;
  max-width: 100%;
`;

export const IconContainer = styled.div`
  align-self: center;
  display: ${props => props.isShowIcon ? 'flex' : 'none'};
  margin-inline-start: ${(props) => props.marginInlineStart};
  margin-inline-end: ${(props) => props.marginInlineEnd};
  margin-bottom: ${(props) => props.marginBottom};
`;

export const Loader = styled.div`
  border: 2px solid #f3f3f3; /* Light grey */
  border-top: 2px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 12px;
  height: 12px;
  animation: spin 2s linear infinite;

  @keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
`;
